
import { useState, useEffect } from "react";
import { Site, getSiteById } from "@/services/sitesApi";
import { useToast } from "@/components/ui/use-toast";

export const useSiteData = (siteId: string) => {
  const [loading, setLoading] = useState(true);
  const [site, setSite] = useState<Site | null>(null);
  const { toast } = useToast();

  useEffect(() => {
    const loadSite = async () => {
      setLoading(true);
      try {
        const siteData = await getSiteById(siteId);
        
        if (siteData) {
          setSite(siteData);
        } else {
          toast({
            title: "Site non trouvé",
            description: "Nous n'avons pas pu trouver les informations de ce site.",
            variant: "destructive",
          });
        }
      } catch (error) {
        console.error("Failed to load site:", error);
        toast({
          title: "Erreur de chargement",
          description: "Impossible de charger les informations. Veuillez réessayer plus tard.",
          variant: "destructive",
        });
      } finally {
        setLoading(false);
      }
    };

    loadSite();
  }, [siteId, toast]);

  return { loading, site };
};
